import React, { useEffect, useState } from 'react'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const SearchBar = ({
  onSearch,
  onSubmit,
  placeholder,
  initialValue = '',
  submitPath = '/search',
  submitParam = 'q'
}) => {
  const { t } = useTranslation()
  const [query, setQuery] = useState(initialValue)
  const navigate = useNavigate()
  const resolvedPlaceholder = placeholder || t('search.searchPlaceholder')

  useEffect(() => {
    setQuery(initialValue)
  }, [initialValue])

  const handleChange = (e) => {
    const value = e.target.value
    setQuery(value)
    if (onSearch) {
      onSearch(value)
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const trimmedQuery = query.trim()
    if (!trimmedQuery) return

    if (onSubmit) {
      onSubmit(trimmedQuery)
      return
    }

    if (!onSearch) {
      navigate(`${submitPath}?${submitParam}=${encodeURIComponent(trimmedQuery)}`)
    }
  }

  const handleClear = () => {
    setQuery('')
    if (onSearch) {
      onSearch('')
    }
  }

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <input
        type="text"
        value={query}
        onChange={handleChange}
        placeholder={resolvedPlaceholder}
        className="input-modern pl-12 pr-10"
      />
      <MagnifyingGlassIcon className="absolute left-4 top-3.5 h-5 w-5 text-sport-silver/50" />
      {query && (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-4 top-3.5 text-sport-silver/50 hover:text-sport-primary transition-colors"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>
      )}
    </form>
  )
}

export default SearchBar
